// extracted by mini-css-extract-plugin
module.exports = {"list":"style_list__5SJbq","listItem":"style_listItem__NQq3m","items":"style_items__1lURr","tag":"style_tag__q7oiU","overlay":"style_overlay__1cR5J"};